/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementQuickStackCellIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ElementQuickStackCellIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            opacity="0.4"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 2C13.5523 2 14 2.44772 14 3V13C14 13.5177 13.6067 13.9438 13.1025 13.9951L13 14H3L2.89746 13.9951C2.42703 13.9472 2.05278 13.573 2.00488 13.1025L2 13V3C2 2.44772 2.44772 2 3 2H13ZM3 13H7.5V8.5H3V13ZM8.5 13H13V8.5H8.5V13ZM3 7.5H7.5V3H3V7.5ZM8.5 7.5H13V3H8.5V7.5Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 2C2.44772 2 2 2.44772 2 3V7.5C2 8.05228 2.44772 8.5 3 8.5H7.5C8.05228 8.5 8.5 8.05228 8.5 7.5V3C8.5 2.44772 8.05228 2 7.5 2H3ZM7.5 3H3L3 7.5H7.5V3Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ElementQuickStackCellIcon.tags = [
  'quick stack',
  'stack',
  'stack cell',
  'quick stack cell',
  'cell',
  'grid',
  'layout',
  'organize',
  'window',
  'tiles',
];

ElementQuickStackCellIcon.category = 'Navigator';

ElementQuickStackCellIcon.iconSize = 16;
